
// Do not use this component until we refactor the v-select with something else
export default {
  name: 'SelectComponent',

  props: {
    // for v-model
    value: {
      default: null,
      type: String,
    },
    options: {
      default: () => [],
      type: Array,
    },
    label: {
      default: '',
      type: String,
    },
    placeholder: {
      default: '',
      type: String,
    },
  },

  data: () => ({
    selection: null,
  }),

  watch: {
    value() {
      // Copy prop over to data so we don't mutate props:
      this.selection = this.value;
    },
  },

  created() {
    // Copy prop over to data so we don't mutate props:
    this.selection = this.value;
  },
};
